// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 2rem 1rem;
    font-family: 'Inter', sans-serif;
    max-height: 100vh;
    overflow-y: auto;
}

.dashboard-title {
    text-align: left;
    font-size: 3rem;
    color: #222;
    margin-bottom: 1rem;
    font-weight: 700;
    max-width: 900px;
}

.dashboard-subtitle {
    text-align: left;
    font-size: 1rem;
    color: #222;
    margin-bottom: 3rem;
    font-weight: 400;
    max-width: 800px;
}

.synapse-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 1.5rem;
    justify-content: center;
}

.synapse-card {
    border: 1px solid #f1f1f1;
    cursor: pointer;
    background-color: #fff;
    border-radius: 0.5rem;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    padding: 1.5rem;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
}

    .synapse-card:hover {
        transform: translateY(-5px);
        box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
    }

.synapse-icon {
    width: 60px;
    height: 60px;
    margin-bottom: 1rem;
}

.synapse-card h2 {
    font-size: 1.25rem;
    color: #333;
    margin-bottom: 0.75rem;
    font-weight: 600;
}

.synapse-card p {
    font-size: 0.875rem;
    color: #666;
    margin-bottom: 1rem;
}

.synapse-link {
    color: #0E3342;
    text-decoration: none;
    font-weight: 500;
    transition: color 0.3s ease;
}

    .synapse-link:hover {
        color: #38EF7D;
    }

@media (max-width: 1200px) {
    .synapse-grid {
        grid-template-columns: repeat(3, 1fr);
    }
}

@media (max-width: 900px) {
    .synapse-grid {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 600px) {
    .dashboard-title {
        font-size: 2rem;
    }

    .synapse-grid {
        grid-template-columns: 1fr;
    }
}
`, "",{"version":3,"sources":["webpack://./src/app/components/pages/dashboard.page.css"],"names":[],"mappings":"AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,gCAAgC;IAChC,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,sBAAsB;IACtB,qBAAqB;IACrB,wCAAwC;IACxC,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,qDAAqD;AACzD;;IAEI;QACI,2BAA2B;QAC3B,0CAA0C;IAC9C;;AAEJ;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,gBAAgB;IAChB,2BAA2B;AAC/B;;IAEI;QACI,cAAc;IAClB;;AAEJ;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,0BAA0B;IAC9B;AACJ","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');\n\n.dashboard-container {\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 2rem 1rem;\n    font-family: 'Inter', sans-serif;\n    max-height: 100vh;\n    overflow-y: auto;\n}\n\n.dashboard-title {\n    text-align: left;\n    font-size: 3rem;\n    color: #222;\n    margin-bottom: 1rem;\n    font-weight: 700;\n    max-width: 900px;\n}\n\n.dashboard-subtitle {\n    text-align: left;\n    font-size: 1rem;\n    color: #222;\n    margin-bottom: 3rem;\n    font-weight: 400;\n    max-width: 800px;\n}\n\n.synapse-grid {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 1.5rem;\n    justify-content: center;\n}\n\n.synapse-card {\n    border: 1px solid #f1f1f1;\n    cursor: pointer;\n    background-color: #fff;\n    border-radius: 0.5rem;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n    padding: 1.5rem;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n    .synapse-card:hover {\n        transform: translateY(-5px);\n        box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);\n    }\n\n.synapse-icon {\n    width: 60px;\n    height: 60px;\n    margin-bottom: 1rem;\n}\n\n.synapse-card h2 {\n    font-size: 1.25rem;\n    color: #333;\n    margin-bottom: 0.75rem;\n    font-weight: 600;\n}\n\n.synapse-card p {\n    font-size: 0.875rem;\n    color: #666;\n    margin-bottom: 1rem;\n}\n\n.synapse-link {\n    color: #0E3342;\n    text-decoration: none;\n    font-weight: 500;\n    transition: color 0.3s ease;\n}\n\n    .synapse-link:hover {\n        color: #38EF7D;\n    }\n\n@media (max-width: 1200px) {\n    .synapse-grid {\n        grid-template-columns: repeat(3, 1fr);\n    }\n}\n\n@media (max-width: 900px) {\n    .synapse-grid {\n        grid-template-columns: repeat(2, 1fr);\n    }\n}\n\n@media (max-width: 600px) {\n    .dashboard-title {\n        font-size: 2rem;\n    }\n\n    .synapse-grid {\n        grid-template-columns: 1fr;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
